import ManualBuyerRegistration from './manual-buyer-registration'

export default ManualBuyerRegistration
